function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import './App.css';
import BlocklyJS from 'blockly/javascript';
import BlocklyComponent, { Block, Category } from './Blockly';
import { Provider } from 'react-redux';
import './blocks/customblocks';
import './generator/generator';
import store from './redux/store';
import UnityWorld from './unity/UnityWorld';

var CS2NBlockly = function CS2NBlockly() {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      code = _useState2[0],
      setCode = _useState2[1];

  useEffect(function () {
    BlocklyJS.simpleWorkspace.workspace.addChangeListener(function () {
      generateCode();
    });
  }, []);

  var generateCode = function generateCode() {
    setCode(BlocklyJS.workspaceToCode(BlocklyJS.simpleWorkspace.workspace));
  };

  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement("div", {
    className: "App"
  }, /*#__PURE__*/React.createElement(UnityWorld, {
    code: code
  }), /*#__PURE__*/React.createElement(BlocklyComponent, {
    ref: function ref(e) {
      return BlocklyJS.simpleWorkspace = e;
    },
    readOnly: false,
    move: {
      scrollbars: false,
      drag: true,
      wheel: true
    }
  }, /*#__PURE__*/React.createElement(Category, {
    name: "Robot",
    colour: "5"
  }, /*#__PURE__*/React.createElement(Category, {
    name: "Movement",
    colour: "25"
  }, /*#__PURE__*/React.createElement(Block, {
    type: "drive"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "driveStop"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "turn"
  })), /*#__PURE__*/React.createElement(Category, {
    name: "Sensors",
    colour: "50"
  }, /*#__PURE__*/React.createElement(Block, {
    type: "touchSensor"
  }))), /*#__PURE__*/React.createElement(Category, {
    name: "Logic",
    colour: "210"
  }, /*#__PURE__*/React.createElement(Block, {
    type: "logic_waitForSeconds"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "shootTorpedo"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "logic_boolean"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "controls_if"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "controls_ifelse"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "logic_compare"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "logic_operation"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "logic_negate"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "logic_null",
    disabled: "true"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "logic_ternary"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "logic_waitUntil"
  })), /*#__PURE__*/React.createElement(Category, {
    name: "Loops",
    colour: "120"
  }, /*#__PURE__*/React.createElement(Block, {
    type: "controls_repeat"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "controls_whileUntil"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "controls_for"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "controls_forEach"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "controls_flow_statements"
  })), /*#__PURE__*/React.createElement(Category, {
    name: "Math",
    colour: "230"
  }, /*#__PURE__*/React.createElement(Block, {
    type: "math_number"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "math_arithmetic"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "math_single"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "math_trig"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "math_constant"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "math_number_property"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "math_round"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "math_on_list"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "math_modulo"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "math_constrain"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "math_random_int"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "math_random_float"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "math_atan2"
  })), /*#__PURE__*/React.createElement(Category, {
    name: "Text",
    colour: "160"
  }, /*#__PURE__*/React.createElement(Block, {
    type: "text"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "text_multiline"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "text_join"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "text_append"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "text_length"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "text_isEmpty"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "text_indexOf"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "text_charAt"
  })), /*#__PURE__*/React.createElement(Category, {
    name: "Lists",
    colour: "260"
  }, /*#__PURE__*/React.createElement(Block, {
    type: "lists_create_empty"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "lists_repeat"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "lists_reverse"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "lists_isEmpty"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "lists_length"
  })), /*#__PURE__*/React.createElement(Category, {
    name: "Variables",
    colour: "330"
  }, /*#__PURE__*/React.createElement(Block, {
    type: "variables_get"
  }), /*#__PURE__*/React.createElement(Block, {
    type: "variables_set"
  })))));
};

export default CS2NBlockly;